export default "__VITE_ASSET__3540fea5__"